<template>
  <svg width="42" height="45" viewBox="0 0 42 45" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M42 45L2.62268e-07 42L3.93402e-06 -3.67176e-06L42 0L42 45Z" fill="#11263D"/>
  <path d="M12.9993 17.5417L12.9993 19.7244L21.2143 13.1826L29.4293 19.7244L29.4293 17.5417L21.2143 10.9999L12.9993 17.5417Z" fill="#CCCCB0"/>
  <path d="M22.2502 13.1826L22.2502 31.2877L20.2673 31.2877L20.2673 13.1826L22.2502 13.1826Z" fill="#CCCCB0"/>
  </svg>
</template>
